export default ({ name, number }) => `${number} - ${name}`;
